/** Names the capability and the way to it, rather than hiding the control. */

import type { CSSProperties, ReactNode } from "react";

import { cn } from "@/lib/cn";

import "../internal/base.css";
import "./EntitlementGate.css";

export interface EntitlementGateProps {
  readonly entitled: boolean;
  /** The capability name off the entitlement, spelled as the api spells it. */
  readonly capability: string;
  readonly action?: ReactNode;
  readonly className?: string;
  readonly style?: CSSProperties;
  readonly children?: ReactNode;
}

export function EntitlementGate({
  entitled,
  capability,
  action,
  className,
  style,
  children,
}: EntitlementGateProps) {
  if (entitled) return <>{children}</>;

  return (
    <div className={cn("al-gate", className)} style={style} role="group" aria-label={capability}>
      <div className="al-gate-main">
        <div className="al-eyebrow">Not included</div>
        <div className="al-gate-capability al-mono">{capability}</div>
      </div>
      {action !== undefined ? <div className="al-gate-action">{action}</div> : null}
    </div>
  );
}
